import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=e738da8e&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=e738da8e&prod&scoped=true&lang=css"
import style1 from "@/assets/css/group_dashboard/change_password.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e738da8e",
  null
  
)

export default component.exports